import { render, staticRenderFns } from "./TabsNew.vue?vue&type=template&id=cb0b8944&"
import script from "./TabsNew.vue?vue&type=script&lang=js&"
export * from "./TabsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UIDiacritics: require('/opt/build/repo/components/UI/Diacritics.vue').default,CoursesCourseOverview: require('/opt/build/repo/components/Courses/CourseOverview.vue').default,CoursesCourseModules: require('/opt/build/repo/components/Courses/CourseModules.vue').default,CoursesDedicatedSupport: require('/opt/build/repo/components/Courses/DedicatedSupport.vue').default,CoursesYourCertificate: require('/opt/build/repo/components/Courses/YourCertificate.vue').default,CoursesCourseRightForYou: require('/opt/build/repo/components/Courses/CourseRightForYou.vue').default})
